import React, { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import useLogout from '../../hooks/useLogout';
import styles from './Profile.module.css';

const menuIcon = require('../../assets/icons/menu.svg').default;
const profileIcon = require('../../assets/icons/profile.svg').default;
const exportIcon = require('../../assets/icons/export.svg').default;

export default function Profile() {
  const { user } = useContext(AuthContext);
  const { logout } = useLogout();

  return (
    <div className={styles.profile}>
      <button className={styles.dropdown} type="button">
        <div>
          <img src={profileIcon} alt="" />
          {user.displayName.split(' ')[0]}
        </div>
        <img src={menuIcon} alt="" />
      </button>
      <div className={styles.dropdownContent}>
        <div className={styles.mobileName}>
          <img src={profileIcon} alt="" />
          {user.displayName.split(' ')[0]}
        </div>
        <button type="button" onClick={() => logout()}>
          <img src={exportIcon} alt="" />
          Log Out
        </button>
      </div>
    </div>
  );
}
